export default {
    view: "Zobacz więcej"
}